import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Sets per-page title + Open Graph + Twitter/X meta at runtime.
//
// Note: The og:image / twitter:image is PLATFORM-WIDE and permanent —
// every route uses the master Liturgical Intelligence™ · Powered by
// Ordo AI™ lockup. Callers cannot override the image. If a caller
// passes `image`, it is deliberately ignored. Only the title and
// description are route-specific.
export const UNIVERSAL_OG_IMAGE = "/images/og-liturgical-intelligence.jpg?v=2";

export default function useSocialMeta({ title, description, path = "" }) {
  useEffect(() => {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const url = origin + (path || window.location.pathname);
    const absImage = origin + UNIVERSAL_OG_IMAGE;

    if (title) document.title = title;
    if (description) upsertMeta("name", "description", description);
    upsertCanonical(url);

    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "Liturgical Intelligence™");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", absImage);
    upsertMeta("property", "og:image:secure_url", absImage);
    upsertMeta("property", "og:image:width", "1200");
    upsertMeta("property", "og:image:height", "630");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", absImage);
  }, [title, description, path]);
}
